module.exports = require("whatwg-url");